import { render, staticRenderFns } from "./UpcomingCompetitions.vue?vue&type=template&id=7244439c&"
import script from "./UpcomingCompetitions.vue?vue&type=script&lang=js&"
export * from "./UpcomingCompetitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports